import axios from "axios";
import authHeader from "@/services/auth-header";

const main = "api/BytePro";
const sub = "ExtendedFields";

class ExtendedFieldsService {
  updateExtendedFields(fileDataId, extendedFields) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/${main}/${sub}?fileDataId=${fileDataId}`,
        extendedFields,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  // updateExtendedBooleanValues(fileDataId, extendedBooleanValues) {
  //   return axios
  //     .put(
  //       `${process.env.VUE_APP_API_BASE_URL}/${main}/${sub}/ExtendedBooleanValues/${fileDataId}`,
  //       extendedBooleanValues,
  //       {
  //         headers: authHeader(),
  //       }
  //     )
  //     .then((response) => {
  //       return response;
  //     });
  // }
  // updateExtendedTextValues(fileDataId, extendedBooleanValues) {
  //   return axios
  //     .put(
  //       `${process.env.VUE_APP_API_BASE_URL}/${main}/${sub}/ExtendedTextValues/${fileDataId}`,
  //       extendedBooleanValues,
  //       {
  //         headers: authHeader(),
  //       }
  //     )
  //     .then((response) => {
  //       return response;
  //     });
  // }
}

export default new ExtendedFieldsService();
